import React, { Component } from 'react';

import {
  Paper, FormControl, TextField, Button, InputLabel, Select, MenuItem, IconButton, Grid,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';

import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import {
  TYPE_MAPPINGS, TASK_TYPES, TASK_TYPE_AND_MODEL_MAPPINGS, BLOCK_TYPES, TOOLS,
} from '../utils/constants';
import MultipleSelect from './MultipleSelect';
import MultipleText from './MultipleText';
import { templateValidationSchema } from '../utils/util';

class TemplateEditForm extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState() {
    return {
      type: '',
      name: '',
      title: '',
      time: '',
      block: '',
      precedings: [],
      ids: [],
      types: Object.keys(TYPE_MAPPINGS),
      refCollection: '',
    };
  }

  componentDidMount() {
    const { templateData } = this.props;
    if (templateData) {
      this.setState({
        _id: templateData._id,
        type: templateData.type,
        name: templateData.name,
        title: templateData.title,
        time: templateData.time,
        block: templateData.block || '',
        precedings: [...templateData.precedings],
        ids: templateData.ids,
        refCollection: templateData.refCollection,
      });
    }
  }

    // eslint-disable-next-line consistent-return
    getIdsData = (type) => {
      const {
        practiceExercises, quizes, assessments, learnExercises, videoTypeExercises, videoUrlTypeExercises,
      } = this.props;
      const taskType = TYPE_MAPPINGS[type];
      switch (taskType) {
        case TASK_TYPES.PRACTICE: return practiceExercises;
        case TASK_TYPES.ASSESSMENT: return assessments;
        case TASK_TYPES.LEARN: return learnExercises;
        case TASK_TYPES.QUIZ: return quizes;
        case TASK_TYPES.URL: return TOOLS;
        case TASK_TYPES.VIDEO: return videoTypeExercises;
        case TASK_TYPES.VIDEO_URL: return videoUrlTypeExercises;
        default:
      }
    }

    chooseTaskType = (event) => {
      this.setState({
        type: event.target.value,
        taskType: TYPE_MAPPINGS[event.target.value],
        refCollection: TASK_TYPE_AND_MODEL_MAPPINGS[TYPE_MAPPINGS[event.target.value]],
      });
    };

    addPreceding=() => {
      this.setState((prevState) => { return { precedings: [...prevState.precedings, ''], ids: this.ids }; });
    };

    removePreceding=(index) => {
      this.setState((prevState) => {
        const precedings = [...prevState.precedings];
        precedings.splice(index, 1);
        return { ...prevState, precedings };
      });
    }

    changedPreceding=(e, index) => {
      e.persist();
      this.setState((prevState) => {
        // eslint-disable-next-line no-param-reassign
        prevState.precedings[index] = e.target.value;
        return { precedings: prevState.precedings, ids: this.ids };
      });
    }

    formupdated=(e) => {
      // eslint-disable-next-line react/no-access-state-in-setstate
      this.setState({ ...this.state, [e.target.name]: e.target.value, ids: this.ids });
    }

    setExercisesIds = (ids) => {
      this.ids = ids;
    }

    submitData = (e) => {
      e.preventDefault();
      const data = {
        name: this.state.name,
        title: this.state.title,
        time: this.state.time,
        precedings: this.state.precedings,
        type: this.state.type,
        block: this.state.block,
        taskType: this.state.taskType,
        refCollection: this.state.refCollection,
        ids: this.ids,
      };
      if (!this.props.creating) {
        data._id = this.state._id;
        templateValidationSchema.validate(data)
          .then(() => {
            return this.props.updateData(data);
          })
          .catch((err) => { return alert(err); });
      } else {
        templateValidationSchema.validate(data)
          .then(() => {
            return this.props.createData(data);
          })
          .catch((err) => { return alert(err); });
      }
      this.props.setformOpen();
    }

    render() {
      const { templateData } = this.props;
      const idsData = this.getIdsData(this.state.type);

      return (
        <div style={{ display: 'flex' }}>
          <Paper style={{ width: '100%', padding: 10, margin: 20 }}>
            <IconButton aria-label="delete" style={{ float: 'right' }} onClick={this.submitData}>
              <CheckCircleOutlineIcon fontSize="default" />
            </IconButton>
            <div>
              <h3>
                {templateData?.name}
              </h3>
            </div>
            {/* <form className="form" onSubmit={this.formSubmitted} autoComplete="off"> */}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <FormControl style={{ width: 120, margin: 10 }}>
                <InputLabel id="simple-select-tasktype-label">Type</InputLabel>
                <Select
                  labelId="simple-select-tasktype-label"
                  id="simple-select-tasktype"
                  value={this.state.type}
                  onChange={this.chooseTaskType}
                  style={{ textAlign: 'left' }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {
                        // eslint-disable-next-line react/no-array-index-key
                        this.state.types && this.state.types.map((type, index) => { return (<MenuItem key={index} value={type}>{type}</MenuItem>); })
                    }
                </Select>
              </FormControl>
              {
                idsData
                  ? (
                    <FormControl style={{ minWidth: 200, margin: 10 }}>
                      <MultipleSelect
                        selectedData={this.state.ids}
                        data={idsData}
                        callBack={this.setExercisesIds}
                        name={`${this.state.type} Exercises`}
                      />
                    </FormControl>
                  )
                  : (
                    <FormControl style={{ minWidth: 200, margin: 10 }}>
                      <MultipleText selectedData={this.state.ids} callBack={this.setExercisesIds} name={`${this.state.type} Exercises`} />
                    </FormControl>
                  )
            }
              <FormControl style={{ width: 120, margin: 10 }}>
                <TextField name="name" label="Name" value={this.state.name} onChange={(e) => { this.formupdated(e); }} />
              </FormControl>
              <FormControl style={{ width: 120, margin: 10 }}>
                <InputLabel id="simple-select-blocktype-label">Block</InputLabel>
                <Select
                  labelId="simple-select-blocktype-label"
                  id="simple-select-tasktype"
                  value={this.state.block}
                  name="block"
                  onChange={this.formupdated}
                  style={{ textAlign: 'left' }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {
                      Object.keys(BLOCK_TYPES).map((type) => { return (<MenuItem key={type} value={type}>{type}</MenuItem>); })
                  }
                </Select>
              </FormControl>
              <FormControl style={{ width: 120, margin: 10 }}>
                <TextField name="title" label="Title" value={this.state.title} onChange={(e) => { this.formupdated(e); }} />
              </FormControl>
              <FormControl style={{ width: 100, margin: 10 }}>
                <TextField name="time" label="Time" value={this.state.time} onChange={(e) => { this.formupdated(e); }} />
              </FormControl>
              {/* <FormControl style={{marginTop: '50px'}}>
                            <Button variant="contained" type="submit" color="primary">Add Task</Button>
                        </FormControl> */}
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {this.state.precedings.map((preceding, index) => {
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <FormControl key={index} style={{ width: 120, margin: 10 }}>
                    <Grid container justify="flex-start">
                      <IconButton onClick={() => { return this.removePreceding(index); }} size="small">
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Grid>
                    <TextField
                      name={`preceding${index}`}
                      label={`Preceding ${index}`}
                      value={this.state.precedings[index]}
                      onChange={(e) => { this.changedPreceding(e, index); }}
                    />
                  </FormControl>
                );
              })}
              <FormControl style={{ margin: 10, paddingTop: 10 }}>
                <Button onClick={this.addPreceding}>Add Precedings</Button>
              </FormControl>
              <br />
            </div>
            {/* </form> */}
          </Paper>
        </div>
      );
    }
}

export default TemplateEditForm;
